import tableRelatedMainHubThirdParty from './tableRelatedMainHubThirdParty';

export default {
  title: 'Blocking Provider',
  attributeName: 'blockingProvider',
  getURL: 'mainHubs/mainHubId/thirdPartyProviders',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRelatedMainHubThirdParty
};
